import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a230ab94"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "summary-path-segment" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", {
  id: "headline_summary",
  class: "text-center mb-5 headline headline--summary"
}, "Preisschätzung für die gewählte Bestattung", -1))
const _hoisted_3 = { class: "row row--results" }
const _hoisted_4 = { class: "col-lg-4 flex-grow chosen-selection-column" }
const _hoisted_5 = { class: "col-lg-8 flex-grow offer-column" }
const _hoisted_6 = { class: "row row--submit" }
const _hoisted_7 = { class: "col-lg-auto ml-lg-auto ms-lg-auto" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = {
  id: "print-result",
  class: "print-container print-only"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_summary_chosen_selection_card = _resolveComponent("summary-chosen-selection-card")!
  const _component_summary_offer_card = _resolveComponent("summary-offer-card")!
  const _component_summary_print_view = _resolveComponent("summary-print-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_summary_chosen_selection_card, {
          "chosen-additional-options": _ctx.chosenAdditionalOptions,
          "chosen-segments-titles": _ctx.chosenSegmentsTitles
        }, null, 8, ["chosen-additional-options", "chosen-segments-titles"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_summary_offer_card, {
          "calculated-price-for-display": _ctx.calculatedPriceForDisplay,
          "calculated-external-price-part-for-display": _ctx.calculatedExternalPricePartForDisplay,
          "calculated-internal-price-part-for-display": _ctx.calculatedInternalPricePartForDisplay,
          "print-container-id": "#print-result"
        }, null, 8, ["calculated-price-for-display", "calculated-external-price-part-for-display", "calculated-internal-price-part-for-display"])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("button", {
          class: "btn btn-danger btn-block",
          type: "button",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.resetConfigurator && _ctx.resetConfigurator(...args)))
        }, " Zurücksetzen")
      ])
    ]),
    (_ctx.morticianAdText)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "mortician-info-text",
          innerHTML: _ctx.morticianAdText
        }, null, 8, _hoisted_8))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_component_summary_print_view, {
        "calculated-price-for-display": _ctx.calculatedPriceForDisplay,
        "calculated-external-price-part-for-display": _ctx.calculatedExternalPricePartForDisplay,
        "calculated-internal-price-part-for-display": _ctx.calculatedInternalPricePartForDisplay,
        "chosen-additional-options": _ctx.chosenAdditionalOptions,
        "chosen-segments-titles": _ctx.chosenSegmentsTitles
      }, null, 8, ["calculated-price-for-display", "calculated-external-price-part-for-display", "calculated-internal-price-part-for-display", "chosen-additional-options", "chosen-segments-titles"])
    ])
  ]))
}